import { SxProps } from '@mui/material';

export const FullPageSpinnerRingStyles: SxProps = {
  height: '100vh',
  width: '100%',
};
